import "./Page.css";
import Component from "react-pure-render/component";
import Helmet from "react-helmet";
import React, { PropTypes } from "react";
import { FormattedHTMLMessage } from "react-intl";
import { Link } from "react-router";
import Isvg from "react-inlinesvg";
import InputWithError from "../components/inputWithError.react";
import Button from "../components/Button.react";
import Dropzone from "react-dropzone";
import {
  isFieldWrong,
  isFormValid
} from "../../common/lib/validationAllFields";
import {
  addNotificationsForInvalidFields,
  focusInvalidField
} from "../lib/validationWeb";

export default class Profile extends Component {
  // static propTypes = {
  //   actions: React.PropTypes.object.isRequired,
  //   msg: React.PropTypes.object,
  // }
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { actions, users: { currentUser } } = this.props;
    actions.clearForm("users", "changePassword");
    actions.clearForm("users", "twoFactorAuth");
  }

  componentDidUpdate(prevProps) {
    const {
      actions,
      users: { forms, currentUser },
      notificationSystem
    } = this.props;
    const {
      users: { forms: prevForms, currentUser: prevCurrentUser }
    } = prevProps;

    if (
      prevCurrentUser &&
      currentUser &&
      prevCurrentUser.uid !== currentUser.uid
    ) {
      actions.setFormField(
        "users",
        "twoFactorAuth",
        "is2FA",
        currentUser && currentUser.is2FA
      );
      actions.setFormField(
        "users",
        "changeProfileDatas",
        "fullName",
        currentUser && currentUser.fullName
      );

      if (!currentUser.is2FA) {
        actions.enableTwoFactorAuthCheckbox().then(({ error, payload }) => {
          if (error) {
            addNotificationsForInvalidFields(payload, notificationSystem);
          }
        });
      }
    }
  }

  onFileSubmit = files => {
    const self = this;
    const { actions, notificationSystem, params } = this.props;

    files.forEach(function(file, index) {
      actions.uploadFile(file).then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        } else {
          actions
            .changeAvatar(
              {
                avatarFileUID: payload.uid
              },
              params.uid
            )
            .then(({ error, payload }) => {
              if (error) {
                addNotificationsForInvalidFields(payload, notificationSystem);
              } else {
                actions.getCurrentUser().then(({ error, payload }) => {
                  if (error) {
                    addNotificationsForInvalidFields(
                      payload,
                      notificationSystem
                    );
                  }
                });
              }
            });
        }
      });
    });
  };

  onChangePasswordFormSubmit = e => {
    e.preventDefault();
    const { actions, users: { forms }, notificationSystem } = this.props;
    actions
      .changePassword(forms.changePassword.fields)
      .then(({ error, payload }) => {
        if (error) {
          focusInvalidField(payload, this, "changePassword");
          addNotificationsForInvalidFields(payload, notificationSystem);
        } else {
          let notification = {
            level: "success",
            message: "Udało się zmienić hasło!",
            position: "br",
            autoDismiss: 5,
            dismissible: true
          };
          notificationSystem.addNotification(notification);
        }
      });
  };

  onChangeProfileDatasFormSubmit = e => {
    e.preventDefault();
    const { actions, users: { forms }, notificationSystem } = this.props;
    actions
      .changeProfileDatas(forms.changeProfileDatas.fields)
      .then(({ error, payload }) => {
        if (error) {
          focusInvalidField(payload, this, "changeProfileDatas");
          addNotificationsForInvalidFields(payload, notificationSystem);
        } else {
          let notification = {
            level: "success",
            message: "Twoje nowe dane zostały ustawione!",
            position: "br",
            autoDismiss: 5,
            dismissible: true
          };
          notificationSystem.addNotification(notification);
        }
      });
  };

  onEnableTwoFactorAuthFormSubmit = e => {
    e.preventDefault();
    const { actions, users: { forms }, notificationSystem } = this.props;
    actions
      .enableTwoFactorAuth(forms.twoFactorAuth.fields)
      .then(({ error, payload }) => {
        if (error) {
          focusInvalidField(payload, this, "twoFactorAuth");
          addNotificationsForInvalidFields(payload, notificationSystem);
        } else {
          actions.getCurrentUser().then(({ error, payload }) => {
            if (error) {
              addNotificationsForInvalidFields(payload, notificationSystem);
            }
          });

          let message = "Udało się wyłączyć podwójną autentykację!";
          if (forms.twoFactorAuth.fields.is2FA) {
            message = "Udało się włączyć podwójną autentykację!";
          }
          let notification = {
            level: "success",
            message: message,
            position: "br",
            autoDismiss: 5,
            dismissible: true
          };
          notificationSystem.addNotification(notification);
        }
      });
  };

  onEnableTwoFactorAuthCheckbox = e => {
    const { actions, users: { currentUser }, notificationSystem } = this.props;
    if (currentUser.is2FA) {
      actions.disableTwoFactorAuthCheckbox();
    } else {
      actions.enableTwoFactorAuthCheckbox().then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        }
      });
    }
  };

  render() {
    const {
      config: { apiHost },
      actions,
      users: { forms, currentUser },
      msg: { users: msg }
    } = this.props;

    const isImageVisible =
      currentUser &&
      !currentUser.is2FA &&
      forms.twoFactorAuth.fields.is2FA &&
      forms.twoFactorAuth.qrCode; // użytkownik ma wyłączone 2FA, chce włączyć i qrCode zwrocony

    const isButtonVisible =
      (currentUser &&
        !currentUser.is2FA &&
        forms.twoFactorAuth.fields.is2FA &&
        forms.twoFactorAuth.qrCode) || // użytkownik ma wyłączone 2FA, chce włączyć
      (currentUser && currentUser.is2FA && forms.twoFactorAuth.fields.is2FA); // użytkownik ma włączone 2FA, chce wyłączyć

    const changePasswordFormProps = {
      feature: "users",
      actions: actions,
      form: forms.changePassword,
      formName: "changePassword",
      msg: msg.forms.changePassword,
      validateFormField: actions.validateFormFieldUsers
    };

    const changeProfileDatasFormProps = {
      feature: "users",
      actions: actions,
      form: forms.changeProfileDatas,
      formName: "changeProfileDatas",
      msg: msg.forms.changeProfileDatas,
      validateFormField: actions.validateFormFieldUsers
    };

    const twoFactorAuthFormProps = {
      feature: "users",
      actions: actions,
      form: forms.twoFactorAuth,
      formName: "twoFactorAuth",
      msg: msg.forms.twoFactorAuth,
      validateFormField: actions.validateFormFieldUsers
    };

    return (
      <div className="islogged-page">
        <Helmet title={msg.title} />
        <div className="row">
          <div className="col-xs-8">
            <div className="row">
              <div className="col-xs-12">
                <div className="box-wrapper">
                  <div className="title">
                    Zmiana hasła
                    <div className="subtitle">
                      Poniżej ustalisz swoje nowe hasło
                    </div>
                  </div>
                  <hr />
                  <div className="content-wrapper">
                    <form
                      onSubmit={this.onChangePasswordFormSubmit}
                      className="add-item"
                      name="changePassword"
                      noValidate
                    >
                      <InputWithError
                        field={"currentPassword"}
                        type="password"
                        placeholder="Wprowadź aktualne hasło"
                        {...changePasswordFormProps}
                      />
                      <InputWithError
                        field={"password"}
                        type="password"
                        placeholder="Wprowadź nowe hasło"
                        {...changePasswordFormProps}
                      />
                      <InputWithError
                        field={"passwordConfirm"}
                        type="password"
                        placeholder="Wprowadź ponownie nowe hasło"
                        {...changePasswordFormProps}
                      />
                      <Button
                        info
                        disabled={
                          forms.changePassword.disabled ||
                          !isFormValid(forms.changePassword)
                        }
                        text="Zmień moje hasło"
                      />
                    </form>
                  </div>
                </div>
              </div>

              {false && (
                <div className="start-xs col-xs-12">
                  <div className="box-wrapper">
                    <div className="title">
                      Podwójne zabezpiecznie konta
                      <div className="subtitle">
                        Aby zabezpieczyć konto, wystarczy aplikacja{" "}
                        <strong>
                          <a
                            href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"
                            target="_blank"
                          >
                            Google Authenticator
                          </a>
                        </strong>
                      </div>
                    </div>
                    <hr />
                    <div className="content-wrapper">
                      <form
                        onSubmit={this.onEnableTwoFactorAuthFormSubmit}
                        className="add-item"
                        name="twoFactorAuth"
                        noValidate
                      >
                        {isImageVisible && (
                          <div className="row center-xs">
                            <div className="col-xs-12">
                              <img
                                className="qr-code"
                                src={
                                  "data:image/png;base64," +
                                  forms.twoFactorAuth.qrCode
                                }
                              />
                            </div>
                          </div>
                        )}
                        {isButtonVisible &&
                        isImageVisible && (
                          <ol>
                            <li>
                              Zeskanuj QR Code aplikacją(Google Authenticator na
                              Androida i iOS'a, Authenticator na Windows Phone)
                            </li>
                            <li>Wprowadź hasło</li>
                            <li>Wprowadź wygenerowany przez aplikację token</li>
                            <li>
                              Zatwierdź, aby włączyć podwójną autentykację
                            </li>
                          </ol>
                        )}
                        {isButtonVisible &&
                        !isImageVisible && (
                          <ol>
                            <li>Wprowadź hasło</li>
                            <li>Wprowadź wygenerowany przez aplikację token</li>
                            <li>
                              Zatwierdź, aby wyłączyć podwójną autentykację
                            </li>
                          </ol>
                        )}
                        {isButtonVisible && (
                          <InputWithError
                            field={"currentPassword"}
                            type="password"
                            placeholder="Wprowadź hasło"
                            {...twoFactorAuthFormProps}
                          />
                        )}
                        {isButtonVisible && (
                          <InputWithError
                            field={"token"}
                            type="number"
                            placeholder="Wprowadź wygenerowany token"
                            {...twoFactorAuthFormProps}
                          />
                        )}
                        {isButtonVisible && (
                          <button
                            className="success"
                            disabled={
                              forms.twoFactorAuth.disabled ||
                              !isFormValid(forms.twoFactorAuth)
                            }
                          >
                            {forms.twoFactorAuth.disabled}
                            {!forms.twoFactorAuth.disabled && "Zatwierdź"}
                          </button>
                        )}
                      </form>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="col-xs-4">
            <div className="row">
              <div className="col-xs-12">
                <div className="box-wrapper">
                  <div className="title">
                    Dane profilowe
                    <div className="subtitle">
                      Zadbaj o to aby Twój profil był uzupełniony w całości.
                    </div>
                  </div>
                  <div className="content-wrapper">
                    <div className="avatar-wrapper">
                      <Dropzone
                        onDrop={this.onFileSubmit}
                        className="dropzone"
                        activeClassName="dropzone-active"
                      >
                        <div>
                          {currentUser &&
                          currentUser.avatar &&
                          currentUser.avatar.uid && (
                            <img
                              src={`${apiHost}/v1/files/${currentUser.avatar
                                .uid}/file`}
                            />
                          )}
                          <Isvg
                            className="dropzone-icon"
                            src="/assets/img/icon_upload.svg"
                          />
                          <p className="dropzone-text">
                            Upuść lub kliknij aby zmienić zdjęcie
                          </p>
                        </div>
                      </Dropzone>
                      <form
                        onSubmit={this.onChangeProfileDatasFormSubmit}
                        name="changeProfileDatas"
                        noValidate
                      >
                        <InputWithError
                          field={"fullName"}
                          type="text"
                          placeholder="Wprowadź imię i nazwisko"
                          {...changeProfileDatasFormProps}
                        />
                        <Button
                          info
                          disabled={
                            forms.changeProfileDatas.disabled ||
                            !isFormValid(forms.changeProfileDatas)
                          }
                          text="Zmień moje dane"
                        />
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/profile/Page.react.js